import "./NotFound.css";
import { FaHome, FaArrowLeft, FaMapMarkerAlt } from "react-icons/fa";

export default function NotFound() {
  return (
    <div className="notfound-page">

      <div className="blob blob1"></div>
      <div className="blob blob2"></div>
      <div className="blob blob3"></div>

      <div className="notfound-card">

        <div className="illustration">

          <div className="orbit orbit1"></div>
          <div className="orbit orbit2"></div>

          <div className="marker">
            <FaMapMarkerAlt />
          </div>

        </div>

        <div className="error-number">
          404
        </div>

        <h1>
          Page Not Found
        </h1>

        <p>
          Looks like this page has wandered off the learning path.
          The link may be outdated, or the page may have been moved.
        </p>

        <div className="button-row">

          <button
            className="btn btn-light action-btn"
            onClick={() => window.history.back()}
          >
            <FaArrowLeft />
            Go Back
          </button>

          <button
            className="btn home-btn action-btn"
            onClick={() => (window.location.href = "/")}
          >
            <FaHome />
            Home
          </button>

        </div>

      </div>

    </div>
  );
}